import { lazy } from "react";

const create = lazy(() => import("./Create").then(m => ({ default: m.NotesCreate })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.NoteEdit })));

export default { create, edit };
